import React, { useState } from "react";
import { FaChevronDown, FaFilter, FaSearch, FaTimes } from "react-icons/fa";

function ArbitrageToolbar({
  modes,
  activeMode,
  search,
  resultsCount,
  onModeChange,
  onSearchChange,
  onReset,
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="sticky top-[88px] z-30 rounded-[2rem] border border-slate-200 bg-white/95 p-4 shadow-xl shadow-slate-200/60 backdrop-blur-xl dark:border-white/10 dark:bg-slate-900/95 dark:shadow-black/20 lg:top-[104px]">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <p className="text-sm font-bold text-slate-950 dark:text-white">
            {activeMode === "quiz"
              ? "Mode quiz arbitrage"
              : `${resultsCount} section${resultsCount > 1 ? "s" : ""} affichée${resultsCount > 1 ? "s" : ""}`}
          </p>

          <p className="mt-1 text-xs font-medium text-slate-500 dark:text-white/45">
            Choisis un onglet : arbitrage, commissaires sportifs ou quiz.
          </p>
        </div>

        <button
          type="button"
          onClick={() => setIsOpen((prev) => !prev)}
          className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl bg-slate-950 px-4 py-2 text-sm font-bold text-white transition hover:-translate-y-0.5 dark:bg-white dark:text-slate-950"
        >
          <FaFilter />
          Filtres
          <FaChevronDown className={`transition ${isOpen ? "rotate-180" : ""}`} />
        </button>
      </div>

      <div className="mt-4 grid gap-3 lg:grid-cols-[1fr_2fr]">
        <select
          value={activeMode}
          onChange={(event) => onModeChange(event.target.value)}
          className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-950 px-4 text-sm font-bold text-white outline-none transition focus:border-amber-300 focus:ring-4 focus:ring-amber-100 dark:border-white/10 dark:bg-white dark:text-slate-950"
        >
          {modes.map((mode) => (
            <option key={mode.value} value={mode.value}>
              {mode.label}
            </option>
          ))}
        </select>

        <label className="relative block">
          <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

          <input
            type="search"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            disabled={activeMode === "quiz"}
            placeholder={
              activeMode === "quiz"
                ? "Recherche désactivée en mode quiz"
                : "Rechercher une règle, une pénalité, un terme..."
            }
            className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 pl-11 pr-4 text-sm font-bold text-slate-700 outline-none transition placeholder:text-slate-400 focus:border-amber-300 focus:bg-white focus:ring-4 focus:ring-amber-100 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/10 dark:bg-white/[0.05] dark:text-white dark:focus:border-amber-300/50 dark:focus:bg-slate-950 dark:focus:ring-amber-500/10"
          />
        </label>
      </div>

      {isOpen && (
        <div className="mt-4 rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.03]">
          <div className="flex flex-wrap gap-2">
            {modes.map((mode) => {
              const isActive = activeMode === mode.value;

              return (
                <button
                  key={mode.value}
                  type="button"
                  onClick={() => onModeChange(mode.value)}
                  className={`inline-flex min-h-11 items-center justify-center rounded-2xl px-4 py-2 text-sm font-bold transition ${
                    isActive
                      ? "bg-amber-600 text-white shadow-lg shadow-amber-500/20"
                      : "border border-slate-200 bg-white text-slate-700 hover:-translate-y-0.5 hover:border-amber-200 hover:text-amber-700 dark:border-white/10 dark:bg-slate-950 dark:text-white"
                  }`}
                >
                  {mode.label}
                </button>
              );
            })}
          </div>

          <div className="mt-4 flex justify-end">
            <button
              type="button"
              onClick={onReset}
              className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 transition hover:-translate-y-0.5 hover:border-red-200 hover:text-red-600 dark:border-white/10 dark:bg-slate-950 dark:text-white"
            >
              <FaTimes />
              Réinitialiser
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ArbitrageToolbar;